import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    LeaseType,
    CollectionServiceType,
    DeliveryServiceType,
} from 'app/enums/label.enums'
import {
    Lane,
} from 'app/Apps/OrderManagement/Lanes/lanes.types'

const config: SkyNetTableConfig = {
    name: 'Pricing.Lanes.AirTransport',
    tabs: [{
        name: 'All',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'laneNumber',
                labelKey: 'AccountLane.lane',
            },
            {
                name: 'laneGroupNumber',
                labelKey: 'Lane.laneGroup',
            },
            {
                name: 'customerQuotationLocationName',
                filterField: 'customerQuotationLocationName',
                filterType: FilterType.Array,
            },
            {
                name: 'customerExecutionLocationName',
                filterField: 'customerExecutionLocationName',
                filterType: FilterType.Array,
            },
            {
                name: 'pricingAccountCompanyName',
                filterField: 'pricingAccountCompanyName',
                labelKey: 'Lane.pricingAccount',
                filterType: FilterType.Array,
                mapCellProps: ({
                    hasNDA,
                    pricingAccountCompanyName,
                }) => {
                    return {
                        children: `${hasNDA ? 'NDA' : pricingAccountCompanyName}`,
                    }
                },
            },
            {
                id: 'leaseType',
                headerProps: {
                    children: 'Lease Type',
                },
                mapCellProps: 'leaseType',
                componentName: 'EnumValue',
                filterField: 'leaseType',
                filterType: FilterType.Array,
                allowedValuesEnum: LeaseType,
            },
            {
                name: 'consigneeLocationName',
                mapCellProps: ({
                    consigneeLocationName,
                    consigneeProvisional,
                }: Lane) => {
                    return {
                        children: consigneeLocationName || consigneeProvisional,
                    }
                },
            },
            {
                name: 'deliveryServiceType',
                filterField: 'deliveryServiceType',
                filterType: FilterType.Array,
                componentName: 'EnumValue',
                allowedValuesEnum: DeliveryServiceType,
            },
            {
                name: 'collectionServiceType',
                filterField: 'collectionServiceType',
                filterType: FilterType.Array,
                componentName: 'EnumValue',
                allowedValuesEnum: CollectionServiceType,
            },
            {
                name: 'originAirportIataCode',
                filterField: 'originAirportIataCode',
                filterType: FilterType.Array,
            },
            {
                name: 'destAirportIataCode',
                filterField: 'destAirportIataCode',
                filterType: FilterType.Array,
            },
            {
                name: 'tempRange',
                filterField: 'tempRange',
                filterType: FilterType.Array,
            },
            {
                name: 'laneStatus',
                filterType: FilterType.Array,
                filterField: 'laneStatus',
                componentName: 'LaneStatus',
            },
        ],
    }],
}

export default config
